<template>
  <v-layout row>
    <v-flex>
      <v-text-field ref="verifyCode" v-model="innerCode" validate-on-blur single-line label="验证码" mask="######" required :rules="[rules.required, rules.verifyCode]" />
    </v-flex>
    <v-btn color="#d04a02" outline style="margin-top:12px" :disabled="cGetCodeDisabled" @click="handleVerify">{{ cVerifyButtonText }}</v-btn>
  </v-layout>
</template>

<script>
import { validRequired, validCode } from '@/util/validation'
const InitCountdown = 60
export default {
  props: {
    resendable: {
      type: Boolean,
      default: false
    },
    verifyCode: {
      type: Function,
      default: () => {}
    },
    code: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      countdown: InitCountdown,
      innerCode: '',
      rules: {
        required: validRequired,
        verifyCode: validCode
      }
    }
  },
  computed: {
    cVerifyButtonText() {
      if (this.countdown === InitCountdown) {
        return '获取验证码'
      }
      return `${this.countdown}s后重试`
    },
    cGetCodeDisabled() {
      if (this.countdown !== InitCountdown) {
        return true
      }
      return !this.resendable
    }
  },
  watch: {
    innerCode: {
      handler(val) {
        if (val.length > 6) {
          this.innerCode = val.substr(0, 6)
          this.$refs['verifyCode'].internalValue = this.innerCode // 大坑
        }
        this.$emit('update:code', val)
      }
    }
  },
  methods: {
    handleVerify() {
      if (this.countdown !== InitCountdown) {
        return
      }

      this.countdown -= 1
      this.timer = setInterval(() => {
        if (this.countdown === 0) {
          this.countdown = InitCountdown
          return clearInterval(this.timer)
        }
        this.countdown -= 1
      }, 1000)

      return this.verifyCode()
    }
  }
}
</script>
